import { Button, Typography, Box } from "@mui/material";

import { FormProvider, useForm } from "react-hook-form";
import DrinkingScheduleStepRadioButtons from "./RadioButtons/DrinkingScheduleStepRadioButtons";
import { useState } from "react";

const drinkingShedule = [
  { id: "1", label: "Daily", value: "Daily" },
  { id: "2", label: "5 times a week", value: "5 Times a week" },
  { id: "3", label: "3 times a week", value: "3 Times a week" },
  { id: "4", label: "Once a week", value: "Once a week" },
  { id: "5", label: "Once a month", value: "Once a month" },
  { id: "5", label: "Once a year", value: "Once a year" },
];

type FormValues = {
  daysOfDrinking: string;
};

const DrinkingScheduleStep = ({
  updateStep,
  previousStep,
  formData,
  setFormData,
}: any) => {
  const methods = useForm<FormValues>({
    defaultValues: {
      daysOfDrinking: formData.drinkScheduleStep.daysOfDrinking,
    },
    mode: "onChange",
  });

  const [clickButton, setClickButton] = useState(false);

  const { handleSubmit } = methods;

  const formSubmit = (data: any) => {
    setFormData({
      ...formData,
      drinkScheduleStep: data.target.defaultValue,
    });
    setClickButton(true);
    setTimeout(() => {
      updateStep();
    }, 500);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(formSubmit)}>
          <Box
            sx={{
              height: { xs: "400px", lg: "502px" },
              width: { xs: "100%", lg: "100%" },

              display: "flex",
              background: "#F2F2F2",
              borderTopRightRadius: { xs: 0, lg: "18px" },
              borderBottomRightRadius: { xs: "18px", lg: "18px" },
              borderBottomLeftRadius: { xs: 18, lg: "0" },
              flexDirection: "column",
              padding: { xs: "0 10px 0 10px", lg: "0" },

              justifyContent: "flex-start",
              flexGrow: "1",
            }}
          >
            <Box
              sx={{
                padding: { xs: "0 10px 25% 10px", lg: "25px 0 0% 0 " },
                margin: { xs: "-70px 0 0 0", lg: "0% 0 0 0" },
                width: "100%",

                display: { xs: "none", lg: "flex" },
                justifyContent: { xs: "space-between", lg: "flex-start" },
                zIndex: "5",
              }}
            >
              <Button
                onClick={previousStep}
                sx={{
                  height: "2.7rem",
                  borderRadius: "50px",
                  width: { xs: "50%", lg: "7rem" },
                  color: "#FF3A18",

                  background: "transparent",
                  ":hover": {
                    bgcolor: "transparent",
                    color: "#FF3A18",
                  },
                }}
                type="submit"
                variant="text"
              >
                <Typography
                  sx={{
                    fontFamily: "Manrope",
                    textTransform: "capitalize",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                >
                  Back
                </Typography>
              </Button>
            </Box>

            <Box
              sx={{
                paddingTop: { xs: "0", lg: "0" },
              }}
            ></Box>
            <Box
              className="transitions"
              sx={{
                position: "relative",
                display: "flex",
                alignSelf: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box>
                {" "}
                <DrinkingScheduleStepRadioButtons
                  name="daysOfDrinking"
                  options={drinkingShedule}
                  onClickButton={formSubmit}
                />
                <Box
                  sx={{
                    padding: { xs: "25px 25px 0% 0", lg: "0 0 4% 0 " },
                    margin: { xs: "-0 0 0 0", lg: "0 0 20px 0" },
                    display: { xs: "flex", lg: "none" },
                    justifyContent: {
                      xs: "space-between",
                      lg: "space-between",
                    },
                    zIndex: "5",
                  }}
                >
                  <Button
                    onClick={previousStep}
                    sx={{
                      height: "2.7rem",
                      borderRadius: "50px",
                      width: { xs: "0%", lg: "7rem" },
                      color: "#FF3A18",

                      background: "transparent",
                      ":hover": {
                        bgcolor: "transparent",
                        color: "#FF3A18",
                      },
                    }}
                    type="submit"
                    variant="text"
                  >
                    <Typography
                      sx={{
                        fontFamily: "Manrope",
                        textTransform: "capitalize",
                        fontWeight: "600",
                        fontSize: "18px",
                      }}
                    >
                      Back
                    </Typography>
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </>
  );
};

export default DrinkingScheduleStep;
